module.exports = __webpack_public_path__ + "img/Satisfeito_Corpo_1.0cdde2cb.png";